(function () {
  'use strict';

  function initTrustCarousel(trustGrid, trustDotsWrap) {
    var trustItems = trustGrid.querySelectorAll('.trust-signal');
    if (trustItems.length <= 1) return;

    var mql = window.matchMedia('(max-width: 768px)');
    var raf = null;

    function buildDots() {
      trustDotsWrap.innerHTML = '';
      for (var i = 0; i < trustItems.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'trust-signals__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.dataset.index = i;
        trustDotsWrap.appendChild(dot);
      }
    }

    function getActive() {
      var rect = trustGrid.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var closest = 0, closestDist = Infinity;
      for (var i = 0; i < trustItems.length; i++) {
        var r = trustItems[i].getBoundingClientRect();
        var dist = Math.abs(r.left + r.width / 2 - center);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      }
      return closest;
    }

    function updateDots() {
      var idx = getActive();
      trustDotsWrap.querySelectorAll('.trust-signals__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    function scrollToItem(index) {
      var item = trustItems[index];
      if (!item) return;
      var offset = item.offsetLeft - (trustGrid.offsetWidth - item.offsetWidth) / 2;
      trustGrid.scrollTo({ left: offset, behavior: 'smooth' });
    }

    function onScroll() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateDots);
    }

    function onDotClick(e) {
      var dot = e.target.closest('.trust-signals__dot');
      if (dot) scrollToItem(parseInt(dot.dataset.index, 10));
    }

    function init() {
      buildDots();
      trustGrid.addEventListener('scroll', onScroll, { passive: true });
      trustDotsWrap.addEventListener('click', onDotClick);
    }

    function teardown() {
      trustDotsWrap.innerHTML = '';
      trustGrid.removeEventListener('scroll', onScroll);
      trustDotsWrap.removeEventListener('click', onDotClick);
    }

    mql.addEventListener('change', function (e) {
      if (e.matches) { init(); } else { teardown(); }
    });

    if (mql.matches) init();
  }

  document.querySelectorAll('[data-trust-signals]').forEach(function (grid) {
    var dots = grid.nextElementSibling;
    if (dots && dots.hasAttribute('data-trust-dots')) {
      initTrustCarousel(grid, dots);
    }
  });
}());
